import React from 'react';
import PropTypes from 'prop-types';
import { AlertModal, Text } from '@cashfree-intl/coherent';

import { getItemFromLocalStorage } from 'utils/common';
import { GMAIL_LINK } from '../../constants';

const PaytmReportGenerated = ({ closeModal }) => (
  <AlertModal
    type="success"
    title="Test is successful"
    confirmText="Open Gmail"
    cancelText="Close"
    onConfirm={() => window.open(GMAIL_LINK, '_blank')}
    onClose={closeModal}
    eventNameOnClose="Test_Is_Successful_Close"
    eventNameOnConfirm="Open_Gmail_Confirm"
  >
    <Text variant="p14" color="bodyLight">
      The transaction report has been shared with you on{' '}
      <span className="email w-600">{getItemFromLocalStorage('email')}</span>
      , share it with your PayTM account manager.
      <br />
      <br />
      You will be required to submit the production credentials on
      Cashfree&apos;s dashboard once they are generated on your PayTM dashboard.
    </Text>
  </AlertModal>
);

PaytmReportGenerated.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default PaytmReportGenerated;
